export default __webpack_public_path__ + "static/media/case2 (1).e5e213da.jpg";